<div *ngIf="connectCreating" class="loading">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'trainer_console' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'trainings_title' | translate }}</div>
  <div fxLayout="row" fxLayoutAlign="end start" *ngIf="classesLength !== 0">
    <a mat-raised-button
    color="primary"
    (click)="sidenavclass.open()"
    *ngIf="isContributor && classesLength < 12">
      <mat-icon>add</mat-icon> {{ 'create_class' | translate }}
    </a>
  </div>
  
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">      
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav
        class="sidenav-panel"
        #sidenavclass
        mode="over"
        position="end"
        [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64"
        [disableClose]="true"
      >
        <app-add-class 
        (saved)="sidenavclass.close(); classSaved($event)"
        (cancelled)="sidenavclass.close()"
        (loadingSpinner)="loadingSpinner($event)">
        </app-add-class>
      </mat-sidenav>

      <mat-sidenav
        class="sidenav-panel"
        #sidenaveditclass
        mode="over"
        position="end"
        [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64"
        [disableClose]="true"
      >
        <app-modify-class
          [class]="selectedClass"
          (saved)="sidenaveditclass.close(); classModified($event)"
          (cancelled)="sidenaveditclass.close(); classCancelled($event)"
          (loadingSpinner)="loadingSpinner($event)">
        </app-modify-class>
      </mat-sidenav>

      <mat-sidenav-content>          
        <mat-tab-group #tabGroup class="tab-group" (selectedTabChange)="tabChanged($event)" 
        [selectedIndex]="selectedTabIndex" *ngIf="classesLength !== 0; else noClasses">
          <mat-tab *ngFor="let class of classes; let index = index" class="tab-title">
            <ng-template mat-tab-label>
              <span>{{class.name}} &nbsp; &nbsp; </span>
              <mat-icon class="edit-icon" (click)="modifyClass(class)">edit-icon</mat-icon>
            </ng-template>
            <app-training-list
              [class_id]="class.id"
              [isDataHubEnabled]="isDataHubEnabled"
              (loadingSpinner)="loadingSpinner($event)"
              (modified)="classModified($event)">
            </app-training-list>
          </mat-tab>
        </mat-tab-group>

        <ng-template #noClasses>
          <br/>
          <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isContributor">
            <div style="padding-top: 100px;">
              <img src="../../../assets/imgs/Class.png" style="height: 80px; width: 80px;" />
            </div>
            <br />
            <div class="sub-title">{{ 'no_classes' | translate }}</div>
            <br />
            <div fxLayoutAlign="space-between center">
              <a mat-raised-button
                color="primary"
                (click)="sidenavclass.open()"
              >
                {{ 'create_class' | translate }}
              </a>
            </div>
          </div>
        </ng-template>
      </mat-sidenav-content>
    </mat-sidenav-container>

  </con-page-layout-content>
</con-page-layout>
